<template>
  <div class="addMem">
    <div class="userInfo">
      <div class="headIcon">
        <img :src="sicon"
             alt
             v-if="sicon" />
        <img src="../../assets/images/headericon.png"
             alt
             v-else />
      </div>
      <div class="userR">
        <span class="name">{{uName}}</span>
        <span>您暂未开通VIP会员</span>
      </div>
    </div>
    <div class="list">
      <div class="listTitle">
        <i class="listIcon"></i>
        <span>VIP会员</span>
        <span class="titleN">选择开通时长</span>
      </div>
      <ul class="memList">
        <li class="item"
            :class="{activeItem: item.mdId == itemId}"
            v-for="item in list"
            @click="memCheck(item)"
            :key="item.mdId">
          <span class="itemF">{{item.tiName}}</span>
          <span class="itemL">￥{{item.mdPrice}}</span>
        </li>
      </ul>
    </div>
    <div class="list">
      <div class="listTitle">
        <i class="listIcon huiyuan2"></i>
        <span>会员尊享特权</span>
      </div>
      <ul class="memList">
        <li class="item-t">
          <i class="listIcon gongkai"></i>
          <span>公开课视频免费观看</span>
        </li>
        <li class="item-t">
          <i class="listIcon gongkai2"></i>
          <span>非公开课程免费观看</span>
        </li>
        <li class="item-t">
          <i class="listIcon huiyuanjia"></i>
          <span>海量课程会员价</span>
        </li>
        <li class="item-t">
          <i class="listIcon gaoqing"></i>
          <span>在线高清播放画质</span>
        </li>
      </ul>
    </div>
    <div class="button"
         @click="buyMem">
      <span>立即开通</span>
    </div>
    <div class="buy-success"
         v-if="showSuccess">
      <div class="buy-success-container">
        <img src="../../assets/images/vip.png"
             alt=""
             style="width:60px">
        <img src="../../assets/images/guanbi@2x.png"
             alt=""
             class="close-btn"
             @click="showSuccess = false">
        <div>
          恭喜您已成为CMDHRA平台的VIP会员
        </div>
        <div>
          会员有效期为一年
        </div>
        <div>
          会员到期日：2020.01.21
        </div>
        <button class="btn"
                @click="showSuccess = false">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';

export default {
  data () {
    return {
      keyWord: "",
      sicon: this.wxuser ? (this.wxuser.uIcon ? this.wxuser.uIcon : "") : "",
      list: [],
      activeTab: 1,
      itemId: 1,
      wxuser: "",
      uName: "",
      memItem: "",
      showSuccess: false,
    };
  },
  props: {},
  async mounted () {
    document.title = "添加会员";
    let wxuser = await loginService.getLoginUser()
    if (wxuser) {
      this.uName = wxuser.uName;
    }
    this.getList();
  },
  methods: {
    getList () {
      this.$postHttp(AppSetting.baseUrl + "/member/detail", { id: 2 }).then(res => {
        if (res.data.code == 0) {
          this.list = res.data.data.memDetails;
          this.itemId = res.data.data.memDetails[0].mdId;
          this.memItem = res.data.data.memDetails[0]
        }
      });
    },
    memCheck (item) {
      this.itemId = item.mdId;
      this.memItem = item;
    },
    onBridgeReady (params) {
      var that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: params.nonceStr, //支付签名随机串，不长于 32 位
          package: params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: params.sign //支付签名
        },
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            this.alert("支付成功");
            //that.$router.push({ path: "/myOrder" });
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            this.alert("支付失败！");
          }
        }
      );
    },
    async buyMem () {
      let item = this.memItem;
      let wxuser =await loginService.getLoginUser();
      let param = {
        orderType: 0, //0 vip购买，1 视频购买，2直播购买，3会议购买
        bId: item.mdId,
        originalPrice: item.mdPrice,
        payPrice: item.mdPrice,
        uid: wxuser.uId
      };
      this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then(res => {
        if (res.data.code == 0) {
          const pay_params = res.data.parMap;
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            this.onBridgeReady(pay_params);
          }
        } else if (res.data.code == 2) {
          this.showSuccess = true;
        } else {
          this.confirm(
            "授权失败，点击确定微信授权",
            "取消",
            "确定",
            () => {
              return true;
            },
            () => {
              this.login();
              return true;
            }
          );
        }
      });
    },
    login () {
      loginService.login(this.$router)
      .then(loginUser=>{
        this.wxuser=loginUser
      })
    },
  },
  components: {},
  computed: {}
};
</script>

<style scoped lang="scss">
.addMem {
  background: #f4f5f4;
  font-size: 0.12rem;
  .userInfo {
    overflow: hidden;
    background: #fff;
    overflow: hidden;
    padding: 0.23rem 0.26rem;
    box-sizing: border-box;
  }
  .headIcon {
    float: left;
    width: 0.81rem;
    height: 0.81rem;
    // background: red;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .userR {
    float: left;
    padding-left: 0.24rem;
    font-size: 0.26rem;
    color: #b5b5b5;
    .name {
      color: #05a2ff;
      font-size: 0.32rem;
      display: block;
    }
  }
  .list {
    // padding: 0.28rem 0.3rem;
    box-sizing: border-box;
    background: #fff;
    margin-top: 0.22rem;
  }
  .memList {
    padding: 0.28rem 0.3rem;
  }

  .listTitle {
    font-size: 0.32rem;
    color: #333333;
    padding: 0.28rem 0.3rem;
    border-bottom: 0.01rem solid #dcdcdc;
  }
  .listIcon {
    display: inline-block;
    width: 0.34rem;
    height: 0.27rem;
    background: url("../../assets/images/vip.png") no-repeat;
    background-size: 100% 100%;
  }
  .huiyuan2 {
    background: url("../../assets/images/huiyuan2.png") no-repeat;
    background-size: 100% 100%;
  }
  .gongkai {
    background: url("../../assets/images/gongkai.png") no-repeat;
    background-size: 100% 100%;
  }
  .gongkai2 {
    background: url("../../assets/images/gongkai2.png") no-repeat;
    background-size: 100% 100%;
  }
  .huiyuanjia {
    background: url("../../assets/images/huiyuanjia.png") no-repeat;
    background-size: 100% 100%;
  }
  .gaoqing {
    background: url("../../assets/images/gaoqing.png") no-repeat;
    background-size: 100% 100%;
  }

  .titleN {
    font-size: 0.24rem;
    color: #b5b5b5;
    margin-left: 0.5rem;
  }
  .item {
    line-height: 1.12rem;
    font-size: 0.28rem;
    color: #666666;
    border: 0.01rem solid rgba(242, 242, 242, 1);
    margin-top: 0.1rem;
    border-radius: 10px;
    padding: 0px 0.32rem;
    box-sizing: border-box;
  }
  .activeItem {
    background: #d3efff;
    border: 0.01rem solid #05a2ff;
  }
  .itemF {
    font-size: 0.36rem;
    color: #333333;
    margin-right: 0.15rem;
  }
  .itemL {
    font-size: 0.32rem;
    color: #05a2ff;
    float: right;
  }
  .item-t {
    font-size: 0.28rem;
    color: #666666;
    line-height: 0.65rem;
  }
  .button {
    position: fixed;
    bottom: 0px;
    width: 100%;
    font-size: 0.34rem;
    color: #fff;
    line-height: 0.9rem;
    text-align: center;
    background: #05a2ff;
  }
}
.buy-success {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .buy-success-container {
    padding: 10px 25px;
    position: absolute;
    width: 85vw;
    height: 75vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    text-align: center;
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    .close-btn {
      width: 22px;
      position: absolute;
      top: 10px;
      right: 13px;
    }
    .btn {
      width: 50%;
      margin-top: 30px;
      background: #05a2ff;
      color: #fff;
      border: none;
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/member/addMem.vue